import { autocompleteChangeArg, autocompleteFieldDefault, autocompleteSubmitArg } from 'utils/inputs.tsx';
import { AutocompleteSubmitData, InputChangeArg, InputSubmitArg } from 'types/inputs.ts';
import {
    SupplyRequestEditAutocompleteKey,
    SupplyRequestEditFormBody,
    SupplyRequestEditFormGlobal
} from 'components/Supply/SupplyRequests/PageBody/List/SupplyRequestListEdit.types.ts';
import { FindMaterialAnalogResponseDto } from 'store/api/materialAnalogs.tsx';
import {
    FindSupplyRequestMaterialListByMaterialResponseDto,
    SupplyRequestMaterialMovement, SupplyRequestMaterialSupplier
} from 'store/api/supplyRequestMaterial.tsx';

// *
// STORE
// *

export const supplyRequestEditFormBodyInitialState: SupplyRequestEditFormBody = {
    destination: autocompleteFieldDefault
}

// *
// INPUT PROCESSING FUNCS
// *


type SupplyRequestEditAutocompleteSubmitData = AutocompleteSubmitData & { label: string }


export const onSupplyRequestEditBodyAutocompleteSubmit = ({
    key,
    setFormValue,
}: InputSubmitArg<SupplyRequestEditAutocompleteKey, SupplyRequestEditFormGlobal>) =>
    (data: SupplyRequestEditAutocompleteSubmitData) => {
        if(data.value && data.label) {
            setFormValue(key, autocompleteSubmitArg({ id: data.value, value: data.label }))
            return
        }
        setFormValue(key, autocompleteSubmitArg(data))
    }
export const onSupplyRequestEditBodyAutocompleteChange = ({
    formData,
    key,
    setFormValue,
}: InputChangeArg<SupplyRequestEditAutocompleteKey, SupplyRequestEditFormGlobal>) =>
    (label: string) => {
        if (formData[key]?.name !== label) {
            setFormValue(key, autocompleteChangeArg(label))
        }
    }

export type ReplaceMaterialType = FindMaterialAnalogResponseDto & {
    showInput?: boolean
}

export type AdjustmentMaterialType = FindMaterialAnalogResponseDto & {
    count: number
}

export const getMaterialWithFinalStorage = (material:  FindSupplyRequestMaterialListByMaterialResponseDto) => {

    let movements: SupplyRequestMaterialMovement[] = []

    material.subRows.forEach((subRow) => subRow.movements &&
        subRow.movements.forEach((movement: SupplyRequestMaterialMovement) => {
            if(movements.findIndex((s) => s.warehouseId === movement.warehouseId) > -1) {
                movements = movements.map((s) => {
                    if(s.warehouseId === movement.warehouseId) {
                        return {
                            ...s,
                            move: s.move + movement.move
                        }
                    } else return s
                })
            } else {
                movements.push(movement)
            }
        })
    )

    return {
        ...material,
        movements,
        ordered: movements.reduce((acc, curr) => acc + curr.move, 0),
    }
}

export const getMaterialWithFinalSuppliers = (material:  FindSupplyRequestMaterialListByMaterialResponseDto) => {

    let suppliers: SupplyRequestMaterialSupplier[] = []

    material.subRows.forEach((subRow) => subRow.suppliers &&
        subRow.suppliers.forEach((store: SupplyRequestMaterialSupplier) => {
            if(suppliers.findIndex((s) => s.storeId === store.storeId) > -1) {
                suppliers = suppliers.map((s) => {
                    if(s.storeId === store.storeId) {
                        return {
                            ...s,
                            purchase: s.purchase + store.purchase
                        }
                    } else return s
                })
            } else {
                suppliers.push(store)
            }
        })
    )

    return {
        ...material,
        suppliers,
        purchased: suppliers.reduce((acc, curr) => acc + curr.purchase, 0),
    }
}